<div class="list-wrapper">
  <kgrid
    [apiName]="apiName"
    [label]="label"
    [name]="apiName"
    [areaName]="areaName"
    pathPreFix="HRM"
    reportName="ReligionKindList"
    [inputEditorform]="inputEditorform">
  </kgrid>
</div>
